import { BookOpen, Bell } from "lucide-react";

export default function BlogPage() {
  return (
    <div className="noise-bg min-h-screen pt-20" data-testid="blog-page">
      {/* Hero Section */}
      <section className="section-padding relative overflow-hidden" data-testid="blog-hero-section">
        {/* Background effects */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-cyan-500/10 rounded-full blur-[120px]"></div>
        
        <div className="container-custom relative z-10">
          <div className="max-w-3xl">
            <span className="caption mb-4 block" data-testid="blog-label">Blog & News</span>
            <h1 className="heading-1 text-white mb-6" data-testid="blog-title">
              Insights & <span className="gradient-text">Updates</span>
            </h1>
            <p className="body-large" data-testid="blog-description">
              Stay informed about the latest developments in healthcare technology, 
              medical device innovation, and our company news.
            </p>
          </div>
        </div>
      </section>

      {/* Coming Soon Section */}
      <section className="pb-24 md:pb-32" data-testid="blog-coming-soon-section">
        <div className="container-custom">
          <div className="max-w-xl mx-auto text-center">
            {/* Glass Card */}
            <div className="glass-card rounded-3xl p-12 relative overflow-hidden">
              {/* Glow effect */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[200px] h-[100px] bg-cyan-500/20 rounded-full blur-[60px]"></div>
              
              <div className="relative z-10">
                <div className="w-20 h-20 mx-auto mb-8 rounded-2xl bg-cyan-500/10 border border-cyan-500/30 flex items-center justify-center animate-glow-pulse">
                  <BookOpen className="w-10 h-10 text-cyan-400" />
                </div>
                
                <div className="mb-6">
                  <span className="badge" data-testid="blog-coming-soon-badge">
                    <Bell className="w-3 h-3 mr-1" />
                    Coming Soon
                  </span>
                </div>
                
                <h2 className="text-2xl font-semibold text-white mb-4" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="blog-coming-soon-title">
                  Blog Launching Soon
                </h2>
                
                <p className="body-base mb-6" data-testid="blog-coming-soon-description">
                  We're preparing insightful articles about healthcare innovation, 
                  medical device development, and industry trends.
                </p>
                
                <p className="text-sm text-cyan-400">
                  Subscribe to our newsletter to be notified when we publish new content.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
